import get from 'lodash/get';

import { setCurrentPageId } from '../result/actions.result';
import { SURVEY_CLIENT__TOGGLE_PROGRESS } from '../constants';
import {
  selectSurveyClient,
  selectResult,
  selectClientPages,
  selectCurrentPageIndex,
} from '../selectors';

export const surveyClientToggleProgress = { type: SURVEY_CLIENT__TOGGLE_PROGRESS };

export const surveyClientSetPageIndex = (selectedPageIndex) => (dispatch, getState) => {
  const { pages } = getState();
  const page = pages.find((p) => p.get('position') === selectedPageIndex);
  const action = setCurrentPageId(page.get('id'));
  return dispatch(action);
};

export const surveyClientPrevPage =
  (offset = 1) =>
  (dispatch, getState) => {
    const state = getState();

    const surveyClient = selectSurveyClient(state);
    const result = selectResult(state);
    const pages = selectClientPages(state, surveyClient, result);
    const currentPageIndex = selectCurrentPageIndex(pages, result);

    const position = get(pages, [currentPageIndex - offset, 'position']);
    const action = surveyClientSetPageIndex(position);

    return dispatch(action);
  };
